import { RegressionTypeEnum } from './chart-models';

export const RegressionTransformations = [
  {
    display_name: 'z-transformed',
    value: RegressionTypeEnum.ZTransformed,
  },
  {
    display_name: 'linear',
    value: RegressionTypeEnum.Linear,
  },
  {
    display_name: 'log',
    value: RegressionTypeEnum.Log,
  },
  {
    display_name: '1 - 10 transformation',
    value: RegressionTypeEnum.OneToTen,
  },
];
